const Contact = () => {
    return ( 
        <div className="container mt-4">
            <div className="row text-light justify-content-center">
                <div className="col-md-12 text-center">
                    <h1>Contact</h1>
                </div>
            </div>

        </div>
     );
}
 
export default Contact;